import elementBehaviours from 'corporate/elements'

document.addEventListener('turbolinks:load', elementBehaviours)
